const updateSelection = (selection, item, allowMultiple, isSelected = true) => {
  if (!allowMultiple) return isSelected ? item : null;

  const updatedSelection = [].concat(selection || []);

  const itemIndex = updatedSelection.indexOf(item);

  if (itemIndex === -1 && isSelected) updatedSelection.push(item);
  else if (!isSelected) updatedSelection.splice(itemIndex, 1);

  return updatedSelection;
};

const parseQueryParamsToFilters = (queryParams, dashboardFields = []) => {
  const result = Object.entries(queryParams).reduce((acc, [key, value]) => {
    if (['undefined', 'null'].includes(value)) return acc;

    // Handle page parameter
    if (key === 'page') {
      acc.page = Number(value);
      return acc;
    }

    // Handle query parameter
    if (key === 'query') {
      acc.query = value;
      return acc;
    }

    // Handle sort parameters
    if (key.startsWith('sort-')) {
      if (!acc.sort) acc.sort = [];
      const sortField = key.replace('sort-', '');
      const order = value;

      // Find the full configuration for the sorted field from the passed-in config
      const fieldConfig = dashboardFields.find(f => f.sortField === sortField || f.value === sortField);

      // Check if the field has a sortNestedPath and build the appropriate sort object
      if (fieldConfig && fieldConfig.sortNestedPath) {
        acc.sort.push({
          [sortField]: {
            order: order,
            nested: { path: fieldConfig.sortNestedPath }
          }
        });
      } else {
        // Fallback to the original behavior for non-nested fields
        acc.sort.push({ [sortField]: { order: order } });
      }
      return acc;
    }

    // Remove potential "[]" from keys
    const normalizedKey = key.replace('[]', '');

    // Convert value to array if it's not already
    const values = Array.isArray(value) ? value : [value];

    // Add to filters array in the required format
    if (!acc.filters) acc.filters = [];

    // Check if filter already exists
    const existingFilter = acc.filters.find(f => f.attribute === normalizedKey);
    if (existingFilter) {
      // Append values to existing filter
      existingFilter.values = existingFilter.values.concat(values);
    } else {
      // Create new filter
      acc.filters.push({
        attribute: normalizedKey,
        values: values.map(v => {
          // Convert to number if it's a valid timestamp
          const num = Number(v);
          return !Number.isNaN(num) && v?.length > 8 ? num : v;
        })
      });
    }

    return acc;
  }, { filters: [], sort: [], query: null, page: null });

  return result;
};

const constructQueryString = activeParams => {
  const queryParts = [];

  // Handle page parameter
  if (activeParams.page) {
    queryParts.push(`page=${encodeURIComponent(activeParams.page)}`);
  }

  // Handle query parameter
  if (activeParams.query) {
    queryParts.push(`query=${encodeURIComponent(activeParams.query)}`);
  }

  // Handle filters array
  if (activeParams.filters) {
    activeParams.filters.forEach(filter => {
      filter.values.forEach(value => {
        queryParts.push(`${filter.attribute}=${encodeURIComponent(value)}`);
      });
    });
  }

  // Handle sort parameters with new format
  if (activeParams.sort) {
    activeParams.sort.forEach(sortItem => {
      Object.entries(sortItem).forEach(([key, value]) => {
        queryParts.push(`sort-${key}=${value.order}`);
      });
    });
  }

  return queryParts.join('&');
};

export { parseQueryParamsToFilters, constructQueryString, updateSelection };
